import { ToastProvider, inizializzaTema } from '@aulaviva/ui';
import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { queryClient } from '@/app/query';
import { router } from '@/app/router';
import { ManualeProvider } from '@/manuale/ManualeProvider';
import './index.css';

inizializzaTema('light');

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <ManualeProvider>
          <RouterProvider router={router} />
        </ManualeProvider>
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
